<template>
    <div>
        <Nav currentpath="/research">
            <div id="mainresearch">
                <h1>Publications</h1>
                <!-- <p>
                    My research mostly focus on tree search algorithms for combinatorial optimization.
                    I (try to) develop tree search methods that are competitive with state of the art metaheuristics.
                </p> -->
                <div id="publications">
                    <div class="publicationcat" v-for="cat in publications" :key="cat.name">
                        <h2>{{cat.name}}</h2>
                        <div class="paper" v-for="item in cat.items" :key="`${cat.name}-${item.title}`">
                            <b>{{item.title}}<br/></b>{{item.authors}}
                            <div><i>{{item.where}}</i></div>
                            <div>
                                <a v-for="e in item.actions" :key="e.link" class="fakeicon" :href="e.link">{{e.name}}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <h1>Some of my talks in video</h1>
                <div class="talkdiv" v-for="talk in videos" :key="`${talk.title}-${talk.text}`">
                                        <a v-for="e in talk.actions" :key="e.link" class="fakeicon" :href="e.link">{{e.name}}</a>
<span class="talktitle">{{talk.title}}</span><br/>
                    <span class="talktext">{{talk.text}}</span>
                </div>

                <h1>Various slides</h1>
                <div class="talkdiv" v-for="talk in talks" :key="`${talk.title}-${talk.text}`">
                                        <a v-for="e in talk.actions" :key="e.link" class="fakeicon" :href="e.link">{{e.name}}</a>
<span class="talktitle">{{talk.title}}</span><br/>
                    <span class="talktext">{{talk.text}}</span>
                </div>
            
            </div>
        </Nav>
    </div>
</template>

<script>
import Nav from "../../components/Nav.vue"

export default {
    name: 'Research',
    components: {Nav},
    data() {
        return {
            "publications": [
                { "name": "Journal articles", "items": [
                    {
                        "title": "Do balanced words have a short period?",
                        "where": "Theoretical Computer Science (TCS), Volume 793, 12 November 2019",
                        "keywords": "balanced words, congruence words, exact covering systems",
                        "authors": "Nadia Brauner, Yves Crama, Etienne Delaporte, Vincent Jost, Luc Libralesso",
                        "abstract": "We conjecture that each balanced word on N letters either arises from a balanced word on two letters with a congruence word, or is D-periodic with D <= 2^N-1. Our conjecture arises from extensive numerical experiments. It implies, for any fixed N, the finiteness of the number of balanced words on N letters which do not arise from expanding a balanced word on two letters. It refines a theorem of Graham and Hubert, which states that non-periodic balanced words are congruence expansions of balanced words on two letters. It also relates to Fraenkel's conjecture, which states that for N >= 3, every balanced word with distinct densities d_1 > d_2 ... > d_N satisfies d_i = (2^{N-i})/(2^N-1), since this implies that the word is D-periodic with D = 2^N-1. For N <= 6, we provide a tentative list of the density vectors of balanced words which do not arise from expanding a balanced word with fewer letters. We prove that the list is complete for N=4 letters.",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2019_balanced_words.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2019_balanced_words.bib"}
                        ],
                    }
                ]},
                { "name": "International conferences", "items": [
                    {
                        "title": "Tree search algorithms for the Sequential Ordering Problem",
                        "where": "(ECAI 2020) 24th European Conference on Artificial Intelligence",
                        "keywords": "meta-heuristics, anytime tree search, beam search",
                        "authors": "Luc Libralesso, Abdel-Malik Bouhassoun, Hadrien Cambazard, Vincent Jost",
                        "abstract": "We present a study of several generic tree search techniques applied to the Sequential Ordering Problem. This study enables us to propose a simple and competitive tree search algorithm. It consists of an iterative Beam Search algorithm that favors search over inference and integrates dynamic programming inspired cuts. It proves optimality on half of the SOPLIB instances and finds new best known solutions on 6 among 7 open instances of the benchmark in a small amount of time.",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2019_tree_search_sop.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2019_tree_search_sop.bib"},
                            {"name": "code", "link": "https://gitlab.com/librallu/cats-ts-sop"}
                        ],
                    },
                ]},
                { "name": "Pre-prints", "items": [
                    {
                        "title": "Iterative beam search algorithms for the permutation flowshop",
                        "where": "",
                        "keywords": "",
                        "authors": "Luc Libralesso, Pablo Andres Focke, Aurélien Secardin, Vincent Jost",
                        "abstract": "",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2020_pfsp_ibs.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2020_pfsp_ibs.bib"},
                            {"name": "code", "link": "https://gitlab.com/librallu/cats-pfsp"}
                        ],
                    },
                    {
                        "title": "Longest common subsequence: an algorithmic component analysis",
                        "where": "",
                        "keywords": "",
                        "authors": "Luc Libralesso, Aurélien Secardin, Vincent Jost",
                        "abstract": "",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2020_lcs.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2020_lcs.bib"},
                            {"name": "code", "link": "https://gitlab.com/secardia/cats-ts-lcs"}
                        ],
                    },
                    {
                        "title": "An anytime tree search algorithm for two-dimensional two- and three-staged guillotine packing problems",
                        "where": "",
                        "keywords": "two-dimensional guillotine packing, bin packing, knapsack, strip packing, anytime algorithm, tree search algorithm",
                        "authors": "Florian Fontan, Luc Libralesso",
                        "abstract": "Libralesso and Fontan (2020) proposed an anytime tree search algorithm for the 2018 ROADEF/EURO challenge glass cutting problem. The resulting program was ranked first among 64 participants. In this article, we generalize it and show that it is not only effective for the specific problem it was originally designed for, but is also very competitive and even returns state-of-the-art solutions on a large variety of Cutting and Packing problems from the literature. We adapted the algorithm for two-dimensional Bin Packing, Multiple Knapsack, and Strip Packing Problems, with two- or three-staged exact or non-exact guillotine cuts, the orientation of the first cut being imposed or not, and with or without item rotation. The combination of efficiency, ability to provide good solutions fast, simplicity and versatility makes it particularly suited for industrial applications, which require quickly developing algorithms implementing several business-specific constraints. The algorithm is implemented in a new software package called PackingSolver.",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2020_packingsolver.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2020_packingsolver.bib"},
                            {"name": "code", "link": "https://github.com/fontanf/packingsolver"}
                        ],
                    },
                    {
                        "title": "An anytime tree search algorithm for the 2018 ROADEF/EURO challenge glass cutting problem",
                        "where": "",
                        "keywords": "Anytime tree search, Cutting & Packing, 2018 ROADEF/EURO challenge, Iterative Memory Bounded A*",
                        "abstract": "In this article, we present the anytime tree search algorithm we designed for the 2018 ROADEF/EURO challenge glass cutting problem proposed by the French company Saint-Gobain. The resulting program was ranked first among 64 participants. Its key components are: a new search algorithm called Iterative Memory Bounded A* (IMBA*) with guide functions, a symmetry breaking strategy, and a pseudo-dominance rule. We perform a comprehensive study of these components showing that each of them contributes to the algorithm global performances. In addition, we designed a second tree search algorithm fully based on the pseudo-dominance rule and dedicated to some of the challenge instances with strong precedence constraints. On these instances, it finds the best-known solutions very quickly.",
                        "authors": "Luc Libralesso, Florian Fontan",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2020_roadef_challenge18.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2020_roadef_challenge18.bib"},
                            {"name": "code", "link": "https://github.com/fontanf/roadef2018"}
                        ]
                    },
                    {
                        "title": "Study on partial flexible job-shop scheduling problem under tooling constraints: complexity and related problems",
                        "authors": "Luc Libralesso, Vincent Jost, Khadija Hadj Salem, Florian Fontan, Frédéric Maffray",
                        "where": "",
                        "keywords": "Combinatorial Optimization, Scheduling, Graph theory, Binary matrix visualization",
                        "abstract": "We introduce a new problem, which is an extension of the classical job shop with tooling constraints.  We study it from 3 different aspects:  scheduling,  matrix visualization and vertex ordering in hypergraphs. We prove the equivalence of the different formulations of the problem and use them to prove several of its NP-Hard and polynomial subcases.  This problem allows to find more elegant (andarguably shorter) proofs for several combinatorial problems.  Including \"Can amatrix can be made triangular by permuting rows and columns?\", weak k-visit and a generalization of Johnson’s argument for the two-machines flowshop.",
                        "actions": [
                            {"name": "pdf", "link": "/pdfs/2019_triangle_width.pdf"},
                            {"name": "bibtex", "link": "/bibtex/2019_triangle_width.bib"},
                        ]
                    },
                ]},
            ],
            "videos": [
                {
                    "title": "Tree search algorithms for the sequential ordering problem",
                    "text": "September 20 2020, CPAIOR 2020",
                    "actions": [{"name": "session video", "link": "https://www.youtube.com/watch?v=arezyOJQFw0"}]
                },
                {
                    "title": "my phd defense: anytime tree search for combinatorial optimization (in french)",
                    "text": "G-SCOP lab, july, 24, 2020",
                    "actions": [{"name": "video", "link": "https://www.youtube.com/watch?v=m2r5-ffmCFc"}]
                },
                {
                    "title": "A Heuristic Branch-and-Bound for the EURO/ROADEF 2018 challenge",
                    "text": "June 24, 2019, the 30th European Conference on Operational Research (EURO 2019)",
                    "actions": [{"name": "video", "link": "https://watch.cloudflarestream.com/0e9acf6e4c59011b387b5b56c9df194f"},]
                },
            ],
            "talks": [
                {
                    "title": "Tree search algorithms for the sequential ordering problem",
                    "text": "September 20 2020, CPAIOR 2020",
                    "actions": [{"name": "slides", "link": "/presentations/20_09_CPAIOR.pdf"}]
                },
                {
                    "title": "Tree search algorithms for the sequential ordering problem",
                    "text": "September 2 2020, ECAI 2020",
                    "actions": [{"name": "slides", "link": "/presentations/20_08_ECAI.pdf"}]
                },
                {
                    "title": "Tree search algorithms for the sequential ordering problem",
                    "text": "June 30 2020, CNIA 2020",
                    "actions": [{"name": "slides", "link": "/presentations/20_07_SOP_CNIA.pdf"}]
                },
                {
                    "title": "Anytime tree search for discrete optimization: A tutorial",
                    "text": "April 28 2020, ROSP seminar",
                    "actions": [{"name": "slides", "link": "/presentations/20_04_TS_for_CO.pdf"}]
                },{
                    "title": "Why branch-and-bounds are meta-heuristics: state-of-the-art heuristics from branch-and-bounds",
                    "text": "February, 20, 2020, 21ème congrès annuel de la société Française de Recherche Opérationnelle et d’Aide à la Décision (ROADEF 2020)",
                    "actions": [{"name": "slides", "link": "/presentations/20_02_ROADEF20_BB_MH.pdf"}]
                },{
                    "title": "Tree searches for Sequential Ordering Problem: Contradicting conventional wisdom",
                    "text": "January, 30, 2020, RealOpt Seminar",
                    "actions": [{"name": "slides", "link": "/presentations/20_01_TS_for_SOP_realopt_seminar.pdf"}]
                },{
                    "title": "Tree search for combinatorial optimization",
                    "text": "January 2, 2020, Operations Research and Combinatorial Optimization (ORCO) Master lecture",
                    "actions": [{"name": "slides", "link": "/presentations/20_01_ORCO_tree_search.pdf"}]
                },{
                    "title": "Efficient tree-search algorithms in Optimization and Operation Research",
                    "text": "July 11, 2019, Naverlabs seminar",
                    "actions": [{"name": "slides", "link": "/presentations/19_07_naverlabs_talk.pdf"}]
                },{
                    "title": "A Heuristic Branch-and-Bound for the EURO/ROADEF 2018 challenge",
                    "text": "June 24, 2019, the 30th European Conference on Operational Research (EURO 2019)",
                    "actions": [
                        {"name": "slides", "link": "/presentations/19_06_EURO_slides.pdf"},
                    ]
                },{
                    "title": "Tree Search and the EURO/ROADEF challenge",
                    "text": "May 20, 2019, ROOT team, LIFAT",
                    "actions": [{"name": "slides", "link": "/presentations/19_05_seminaire_tours.pdf"}]
                },{
                    "title": "Tree Search and the EURO/ROADEF challenge",
                    "text": "March 21, 2019, ROSP team, G-SCOP",
                    "actions": [{"name": "slides", "link": "/presentations/19_03_MidiROSP.pdf"}]
                },{
                    "title": "Triangle Width: de l'ordonnancement à la théorie des graphes",
                    "text": "February, 21, 2019, 20ème congrès annuel de la société Française de Recherche Opérationnelle et d’Aide à la Décision (ROADEF 2019)",
                    "actions": [{"name": "slides", "link": "/presentations/19_02_roadef_triangle_width.pdf"}]
                },{
                    "title": "Triangle Width: de l'ordonnancement à la théorie des graphes",
                    "text": "May 31, 2018, ROSP team, G-SCOP",
                    "actions": [{"name": "slides", "link": "/presentations/18_05_rosp_triangle_width.pdf"}]
                },{
                    "title": "Comment la recherche opérationnelle peut elle créer des cerveaux sur puce",
                    "text": "May 17, 2018, G-SCOP days",
                    "actions": [{"name": "slides", "link": "/presentations/18_06_jdd_mstii_presentation.pdf"}]
                },{
                    "title": "Comment la recherche opérationnelle peut elle créer des cerveaux sur puce",
                    "text": "February, 23, 2018, 19ème congrès annuel de la société Française de Recherche Opérationnelle et d’Aide à la Décision (ROADEF 2018)",
                    "actions": [{"name": "slides", "link": "/presentations/18_02_roadef.pdf"}]
                },
            ],
        }
    }
}
</script>

<style lang="scss">
@import "../../styles/common.scss";

#mainresearch {
    padding: 10px;
}

h1 {
    margin-top: 60px;
}

.talkdiv {
    padding: 10px;
    .talktitle {

    }
    .talktext {
        color: $lighttext;
    }
}

.paper {
    border-left: 5px solid #ddd;
    padding-left: 20px;
    margin-bottom: 20px;

    .lightb {
        color: $lighttext;
    }

    .abstract {
        margin-top: 10px;
        div {
            // border: 1px solid #666;
            padding: 0px 0 10px 30px;
            color: $lighttext;
        }
    }
    a {
        padding: 8px;
    }
}

</style>
